import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import CreditFilter from "./creditFilter";
import CreditsData from "./creditsData";
import { getJobGrid as onGetJobGrid } from "slices/thunk";
import Spinners from "Components/Common/Spinner";
import { jobsGridData as CreditData } from "common/data";

const Credits = () => {
  document.title = "Credtis";

  const { t } = useTranslation();

  const dispatch = useDispatch<any>();

  const selectProperties = createSelector(
    (state: any) => state.jobs,
    (jobs) => ({
      jobdata: CreditData,
      loading: false,
    })
  );
  const { jobdata, loading } = useSelector(selectProperties);
  const [jobGrid, setJobGrid] = useState<any>();
  const [isLoading, setLoading] = useState<boolean>(loading);

  useEffect(() => {
    dispatch(onGetJobGrid());
  }, [dispatch]);

  useEffect(() => {
    setJobGrid(jobdata);
  }, [jobdata]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title={`${t("Credits")}`}
            breadcrumbItem={`${t("Credits")}`}
          />

          {/* <CreditFilter setJobGrid={setJobGrid} jobdata={jobdata} /> */}
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <CreditsData jobGrid={jobGrid} />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Credits;
